import { Component } from '@angular/core';

@Component({
    template: `
        No internet connection!
  `
})
export class NoInternetMessageComponent {
}
